import { useState } from 'react'
import { Modal } from '@/components/ui/modal'
import { useChangeAdminRole } from '@/hooks/use-admin-users'
import type { AdminUserRecord } from '@/lib/types'

interface ChangeRoleModalProps {
  user: AdminUserRecord | null
  onClose: () => void
}

export function ChangeRoleModal({ user, onClose }: ChangeRoleModalProps): React.JSX.Element | null {
  const changeRole = useChangeAdminRole()
  const [role, setRole] = useState<'admin' | 'viewer'>(
    user?.role === 'super_admin' ? 'admin' : ((user?.role as 'admin' | 'viewer') ?? 'admin'),
  )

  if (!user) return null

  function handleSubmit(e: React.FormEvent): void {
    e.preventDefault()
    if (!user) return
    changeRole.mutate({ id: user.id, role }, { onSuccess: onClose })
  }

  return (
    <Modal open onClose={onClose} title={`Change Role: ${user.email}`} size="sm">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="change-role-select"
            className="block text-sm font-medium text-text-primary"
          >
            New Role
          </label>
          <select
            id="change-role-select"
            value={role}
            onChange={(e) => setRole(e.target.value as 'admin' | 'viewer')}
            className="mt-1 w-full rounded-lg border border-surface-3 bg-surface-0 px-3 py-2 text-sm text-text-primary"
          >
            <option value="admin">Admin</option>
            <option value="viewer">Viewer</option>
          </select>
        </div>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg px-4 py-2 text-sm font-medium text-text-secondary hover:bg-surface-2"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={changeRole.isPending}
            className="rounded-lg bg-admin-500 px-4 py-2 text-sm font-medium text-white hover:bg-admin-600 disabled:opacity-50"
          >
            {changeRole.isPending ? 'Saving...' : 'Change Role'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
